import React, {useEffect, useState, useContext} from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner, FormFeedback, Input, Form } from 'reactstrap';
import Select from 'react-select';
import { resourcesBranch,resourcesGeofence,resourcesRoutes } from '../../../helpers/backend_helper';
import { getStorageUser,getStorageCompany } from '../../../helpers/api_helper';
import {Alert,ToastHelper} from '../../../helpers/alerts/alertHelper';
import Validate from './Validate'
import { useFormik } from 'formik';
import * as Yup from "yup";
import classNames from "classnames";
import NibbleInput from '../../../components/Fields/NibbleInput';

const YESNO = [
	{ label: "Si", value: true },
	{ label: "No", value: false },
  ]

const AddUpdModal = ({modal,setModal,items, setItems, setItem,item}) => {
	const company = getStorageCompany();
	const [ errors, setErrors ] = useState([]);
	const [ routes, setRoutes ] = useState([]);
	const [geofences, setGeofences] = useState([])
	const [ loading, setLoading ] = useState(false);
	const authUser = getStorageUser();
	const handleClose = () => {
		setModal({...modal,show:false,update:false});
    }

	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {...item},
		validationSchema: Yup.object({
			name: Yup.string().nullable(true).required('Requerido'),
			cost: Yup.number().nullable(true).required('Requerido'),
			active: Yup.boolean().required('Requerido'),
			frecuencia: Yup.number().nullable(true).required("Requerido"),
			route_id: Yup.string().nullable(true).required("Requerido"),
			geofence_route_id: Yup.string().nullable(true),
		}),
		onSubmit: async values => {
			await save(values)
			
		},
	});

    useEffect(() => {
        if(authUser.profile_id!=3){
        	resourcesRoutes('get',{}).then(response => {
        		setRoutes(response.data)
	        })
        }
    }, [])

	useEffect(() => {
		const config = {
			params: {
				select: true,
				tipo: 'ruta'
			}
		}
		const getGeodence =  async() => {
			const response = await resourcesGeofence('get',config)
    		setGeofences(response.data)	
		}
		getGeodence()
    }, [])

	const save = async (data) => {
		try {
		  setLoading(true)
		  const response = modal.update ? await resourcesBranch('put',data,data.id):await resourcesBranch('post',data)
		  responseAction(response)
		  setLoading(false);
		} catch (err) {
		  console.error(err)
		  setLoading(false)
		}
	};

    const responseAction = (response) => {
    	if(response.status){
    		const newItem = response.branch;
    		let array = [];
    		if(modal.update){
    			array = items.map(item => item.id !== newItem.id ? item : newItem);
    		}else{
    			array = [...items, newItem];
    			array.sort((a, b) => {
    				return a.id - b.id;
    			});
    		}
    		setItems(array);
			handleClose()
			setLoading(false)
    	}else{
    		setLoading(false)
    		setErrors(response.response.data.errors)
    	}
    }

    return (
		<div>
	        <Modal isOpen={modal.show}>
				<ModalHeader className="bg-primary">{modal.update ? 'Editar Ramal':'Nueva Ramal'}</ModalHeader>
				<Form
					onSubmit={e => {
						e.preventDefault();
						validation.handleSubmit();
						return false;
					}}
				>
					<ModalBody>
						<div className="row">
							{authUser.profile_id==2 && 
							<div className="mt-2 col-sm-12">
								<label className="form-label">Ruta:</label>
								<Select
									className={classNames({'is-invalid': (validation.touched.route_id && validation.errors.route_id)})}
									classNamePrefix="select"
									isClearable={true}
									value={ routes.filter(e => e.id == validation.values.route_id)[0] ?? null }
									isSearchable={true}
									getOptionLabel={(option) => `${option.name}`}
									getOptionValue={(option) => `${option.id}`}
									name="route_id"
									options={routes}
									onChange={(option, meta) => {validation.setFieldValue('route_id', option.id, true)}}
									invalid={(validation.touched.route_id && validation.errors.route_id)}
								/>
								<FormFeedback type="invalid">{validation.errors.route_id}</FormFeedback>
							</div>
							}
							<div className="mt-2 col-sm-6">
								<label className="form-label">Clave de Ramal:</label>
								<Input
									className="form-control"
									name="clave"
									type="text"
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.clave}
									invalid={(validation.touched.clave && validation.errors.clave)}
								/>
								<FormFeedback type="invalid">{validation.errors.clave}</FormFeedback>
							</div>
							
							<div className="mt-2 col-sm-6">
								<label className="form-label">Nombre de Ramal:</label>
								<Input
									className="form-control"
									name="name"
									type="text"
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.name}
									invalid={(validation.touched.name && validation.errors.name)}
								/>
								<FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
							</div>
							
							<div className="mt-2 col-sm-6">
								<label className="form-label">Activo:</label>
								<Select
									className="basic-single"
									classNamePrefix="select"
									isClearable={true}
									value={ YESNO.filter(e => e.value == validation.values.active)[0] ?? null }
									isSearchable={true}
									name="active"
									options={YESNO}
									onChange={(option, meta) => {validation.setFieldValue('active', option.value, true)}}
									invalid={(validation.touched.active && validation.errors.active)}
								/>
								<FormFeedback type="invalid">{validation.errors.active}</FormFeedback>
							</div>
							<div className="mt-2 col-sm-6">
								<label className="form-label">Costo:</label>
								<Input
									className="form-control"
									name="cost"
									type="number"
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.cost}
									invalid={(validation.touched.cost && validation.errors.cost)}
								/>
								<FormFeedback type="invalid">{validation.errors.cost}</FormFeedback>
							</div>
							<div className="mt-2 col-sm-6">
								<label className="form-label">Frecuencia:</label>
								<Input
									className="form-control"
									name="frecuencia"
									type="number"
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.frecuencia}
									invalid={(validation.touched.frecuencia && validation.errors.frecuencia)}
								/>
								<FormFeedback type="invalid">{validation.errors.frecuencia}</FormFeedback>
							</div>
							<NibbleInput
								md={6}
								label="Geocerca:"
								fieldName="geofence_route_id"
								fieldType="select"
								selectItems={geofences}
								validation={validation}
								/>
						</div>	
					</ModalBody>
					<ModalFooter>
						<Button color="primary" type="submit" disabled={loading}>
							{loading && <Spinner size="sm"></Spinner> } <i className='fa fa-save'></i> Guardar
						</Button>{' '}
						<Button color="secondary" onClick={handleClose}>
							<i className='fa fa-times'></i> Cancelar</Button>
					</ModalFooter>
				</Form>
	        </Modal>
		</div>
	);
}

export default AddUpdModal;